import styled from 'styled-components';
import { theme } from '../../../../constants/theme.mjs';
"use strict";
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 6px;

  > * {
    border-radius: 0;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.athensGreyDark};
    }
  }
`;
const CustomerWrap = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export { ButtonGroup, CustomerWrap, Wrap };
//# sourceMappingURL=Mobile.styles.mjs.map
